import React from "react";
import RegisterComponent from "../template/_common/registerComponent";

const AdminRegister = () => {
  return <RegisterComponent roleType={"admin"} role={"2"} />;
};

export default AdminRegister;
